import React from 'react';
import { Reveal } from './Reveal';
import { SectionLabel } from './SectionLabel';
import { CTAButton } from './CTAButton';
import { insideItems } from '../data/content';
export function InsideSection() {
  return <section className="border-t border-white/5 bg-void-950 py-24 md:py-32" data-id="element-126" data-mp="3jy1ym1amnrzy">
      <div className="mx-auto max-w-4xl px-6" data-id="element-127" data-mp="3oxoao7epz276">
        <Reveal className="max-w-2xl" data-id="element-128" data-mp="3owd7o9t3lyh4">
          <SectionLabel data-id="element-129" data-mp="3a1703iectrlo">Adentro del libro</SectionLabel>
          <h2 className="font-display text-3xl font-light leading-tight text-bone-50 sm:text-4xl md:text-5xl" data-id="element-130" data-mp="39zdv07je3ffs">
            Lo que encontrarás cuando abras estas páginas.
          </h2>
          <p className="mt-6 text-base leading-relaxed text-bone-300 sm:text-lg" data-id="element-131" data-mp="311k8fobfg05t">
            Cada capítulo es una conversación íntima entre tú y aquello que siempre supiste, pero
            que olvidaste recordar.
          </p>
        </Reveal>

        <ol className="mt-14 divide-y divide-white/5 border-y border-white/5" data-id="element-132" data-mp="147ywlwlubkfj">
          {insideItems.map((item, i) => <li key={item} data-id="element-133" data-mp="2zvjp4w9cy5b4" data-mpi={i}>
              <Reveal delay={Math.min(i, 4) * 0.04} data-id="element-134" data-mp="2zuqrqlwags5n">
                <div className="flex items-baseline gap-6 py-6" data-id="element-135" data-mp="2vuq368fh70kv">
                  <span className="neon-text-soft font-display text-lg text-gold-500" data-id="element-136" data-mp="2vu81gwa1nu5k">
                    {String(i + 1).padStart(2, '0')}
                  </span>
                  <p className="text-base leading-relaxed text-bone-100 sm:text-lg" data-id="element-137" data-mp="34ntfgdedx7dx">{item}</p>
                </div>
              </Reveal>
            </li>)}
        </ol>

        <Reveal delay={0.1} data-id="element-138" data-mp="2cw40ip4b91eu">
          <CTAButton label="Quiero leerlo hoy" className="mt-12" data-id="element-139" data-mp="2cwxas02ha91q" />
        </Reveal>
      </div>
    </section>;
}